/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface BlockUnblockFlowMutationProps {
    flow_id: string;
    organisation_id: string;
    pause: boolean;
}

export default class BlockUnblockFlowMutation extends Relay.Mutation<BlockUnblockFlowMutationProps> {
    static propTypes = {
        flow_id: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
        pause: PropTypes.bool.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {blockUnblockFlow}`;
    }

    getVariables() {
        return {
            flow_id: this.props.flow_id,
            organisation_id: this.props.organisation_id,
            pause: this.props.pause,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on BlockUnblockFlowPayload {
              clientMutationId,
              updatedNode {
                  id,
                  realId,
                  enabled,
                  status,
                  activated,
                  paused,
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
